export const PROCESS_AI_IMAGES_REQUEST = 'PROCESS_AI_IMAGES_REQUEST';
const PROCESS_AI_IMAGE_PROGRESS = 'PROCESS_AI_IMAGE_PROGRESS';
export const PROCESS_AI_IMAGES_SUCCESS = 'PROCESS_AI_IMAGES_SUCCESS';
export const PROCESS_AI_IMAGES_FAILURE = 'PROCESS_AI_IMAGES_FAILURE';

export interface AiImage {
  url: string;
  imageBitmap?: ImageBitmap;
}
export interface ProcessAiImagesRequestAction {
  type: typeof PROCESS_AI_IMAGES_REQUEST;
  images: AiImage[];
  pipeline?: 'full' | 'embedded-raster';
}
export const processAiImagesRequest = ({
  images,
  pipeline = 'embedded-raster'
}: Omit<ProcessAiImagesRequestAction, 'type'>): ProcessAiImagesRequestAction => ({
  type: PROCESS_AI_IMAGES_REQUEST,
  images,
  pipeline
});

interface ProcessAiImageProgressAction {
  type: typeof PROCESS_AI_IMAGE_PROGRESS;
  url: string;
  progress: number;
}
export const processAiImageProgress = ({
  url,
  progress
}: Omit<ProcessAiImageProgressAction, 'type'>): ProcessAiImageProgressAction => ({
  type: PROCESS_AI_IMAGE_PROGRESS,
  url,
  progress
});

type ProcessedImages = {
  url: string;
  blob: Blob;
};

export interface ProcessAiImagesSuccessAction {
  type: typeof PROCESS_AI_IMAGES_SUCCESS;
  images: ProcessedImages[];
}
export const processAiImagesSuccess = ({
  images
}: Omit<ProcessAiImagesSuccessAction, 'type'>): ProcessAiImagesSuccessAction => ({
  type: PROCESS_AI_IMAGES_SUCCESS,
  images
});

export interface ProcessAiImagesFailureAction {
  type: typeof PROCESS_AI_IMAGES_FAILURE;
  error: Error;
}
export const processAiImagesFailure = ({
  error
}: Omit<ProcessAiImagesFailureAction, 'type'>): ProcessAiImagesFailureAction => ({
  type: PROCESS_AI_IMAGES_FAILURE,
  error
});
